// extracted by mini-css-extract-plugin
module.exports = {"annotation":"Annotation_annotation__imv5T","label":"Annotation_label__AfEBr","marker":"Annotation_marker__2LskQ","title":"Annotation_title__3Icbb"};